import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // <-- ایمپورت جدید
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* کل برنامه را درون BrowserRouter قرار می‌دهیم */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);